import { Route, Switch } from "react-router";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { Contact } from "../Pages/Contact";
import { Gallery } from "../Pages/Gallery";
import { Gospeldownloads } from "../Pages/Gospeldownloads";
import { Home } from "../Pages/Home";
import { Projekts } from "../Pages/Projekts";
import { SoundCloud } from "../Pages/SoundCloud";
import { GlobalStyle } from "../Styles";

export const Routes = () => {
  return (
    <Switch>
      <Route exact path="/">
        <Header />
        <Home />
        <Footer />
      </Route>
      <Route exact path="/gallery">
        <Header />
        <Gallery />
        <Footer />
      </Route>
      <Route exact path="/projekts">
        <Header />
        <Projekts />
        <Footer />
      </Route>
      <Route exact path="/radiogospel">
        <Header />
        <SoundCloud />
        <Footer />
      </Route>
      <Route exact path="/contact">
        <Header />
        <Contact />
        <Footer />
      </Route>
      <Route exact path="/gospeldownloads">
        <Header />
        <Gospeldownloads />
        <Footer />
      </Route>
      <GlobalStyle />
    </Switch>
  );
};
